import * as React from "react";
const SvgFiRrMarketplace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-marketplace_svg__a)">
      <path
        fill="#062147"
        d="M23.411 15.866A2.5 2.5 0 0 0 22 15.052V14.5c0-2.481-2.019-4.5-4.5-4.5a4.505 4.505 0 0 0-4.5 4.5v.552a2.494 2.494 0 0 0-1.993 2.811l.524 3.573A3.02 3.02 0 0 0 14.499 24h6a3.02 3.02 0 0 0 2.968-2.564l.524-3.573a2.5 2.5 0 0 0-.582-1.997zM17.5 12c1.378 0 2.5 1.122 2.5 2.5v.5h-5v-.5c0-1.378 1.122-2.5 2.5-2.5m3.99 9.145a1.01 1.01 0 0 1-.99.855h-6c-.493 0-.918-.368-.99-.854l-.524-3.573a.5.5 0 0 1 .117-.4.5.5 0 0 1 .378-.173h8.039c.199 0 .322.108.378.173a.5.5 0 0 1 .117.4zM4 4.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 4 4.5m4 0a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 8 4.5M8 20H5c-1.654 0-3-1.346-3-3V9h20v1a1 1 0 0 0 2 0V5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5v12c0 2.757 2.243 5 5 5h3a1 1 0 0 0 0-2M5 2h14c1.654 0 3 1.346 3 3v2H2V5c0-1.654 1.346-3 3-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-marketplace_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMarketplace;
